import React from 'react';
import { FormError } from '/imports/ui/FormError';

const formFieldClassName = [
  'relative',
  '[&.checkbox]:mt-auto [&.checkbox_label]:flex',
  '[&.error_input]:border-2 [&.error_input]:border-red-2 [&.error_input]:text-red-2 [&.error_input]:outline-none',
  '[&.error_select]:border-2 [&.error_select]:border-red-2 [&.error_select]:text-red-2 [&.error_select]:outline-none',
  '[&.error_textarea]:border-2 [&.error_textarea]:border-red-2 [&.error_textarea]:text-red-2 [&.error_textarea]:outline-none',
  '[&_.optional]:ml-1 [&_.optional]:lowercase',
  '[&_.field-tip]:relative [&_.field-tip]:-top-[0.15rem] [&_.field-tip]:left-0 [&_.field-tip]:ml-1',
  '[&_.field-tip_svg]:h-5 [&_.field-tip_svg]:w-5 [&_.field-tip]:text-fg-2',
].join(' ');

interface FormFieldProps {
  id?: string;
  className?: string;
  field: string;
  error?: any;
  children: React.ReactNode;
}

export const FormField = (props: FormFieldProps) => {
  const { id, field, error, children, className } = props;
  const hasError = !!error?.[field]?.[0];
  return (
    <div id={id} className={`field ${formFieldClassName}${hasError ? ' error' : ''}${className ? ` ${className}` : ''}`}>
      {children}
      <FormError field={field} error={error} />
    </div>
  );
};
